import { HealthCard } from "@/components/admin/agenti/HealthCard";
import { Skeleton } from "@/components/ui/skeleton";
import { useAgenteSalute } from "@/hooks/useAgenteSalute";

function fmtDurata(s: number | null): string {
  if (s == null) return "—";
  if (s < 60) return `${s}s`;
  return `${Math.round(s / 60)} min`;
}

interface Kpi {
  label: string;
  valore: string | number;
  sub?: string;
}

export function AgenteSalute({ slug }: { slug: string }) {
  const { data, isLoading } = useAgenteSalute(slug);

  if (isLoading) {
    return (
      <div className="space-y-4">
        <Skeleton className="h-24 w-full" />
        <Skeleton className="h-40 w-full" />
      </div>
    );
  }
  if (!data) return <p className="text-sm text-muted-foreground">Salute non disponibile.</p>;

  const k = data.kpi;
  const kpis: Kpi[] = [
    { label: "Email gestite · oggi", valore: k.email_oggi },
    { label: "In errore / bloccate", valore: `${k.in_errore} / ${k.bloccate}` },
    { label: "Richieste dati pendenti", valore: k.richieste_dati_pendenti },
    { label: "Tempo medio risposta", valore: fmtDurata(k.tempo_medio_risposta_s) },
    {
      label: "Costo AI · 7gg",
      valore: `$${k.costo_ai_7gg_usd.toFixed(2)}`,
      sub: `${k.ai_chiamate_7gg} chiamate`,
    },
  ];

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5">
        {kpis.map((kpi) => (
          <div key={kpi.label} className="rounded-lg border bg-card p-4">
            <div className="text-xs font-medium text-muted-foreground">{kpi.label}</div>
            <div className="mt-1 text-2xl font-bold tracking-tight tabular-nums">
              {kpi.valore}
            </div>
            {kpi.sub && <div className="mt-0.5 text-[11px] text-muted-foreground">{kpi.sub}</div>}
          </div>
        ))}
      </div>

      <div>
        <h3 className="mb-3 text-xs font-bold uppercase tracking-wider text-muted-foreground">
          Stato dei servizi
        </h3>
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {data.servizi.map((s) => (
            <HealthCard key={s.id} s={s} />
          ))}
        </div>
      </div>
    </div>
  );
}
